import React from 'react';
import BrandPolicyPage from '../PolicyPage/BrandPolicyPage';

const PrivacyPolicyPage: React.FC = () => <BrandPolicyPage doc="privacy" />;

export default PrivacyPolicyPage;
